import { useState } from "react";

export default function KYCVerificationStep({ data, setData }) {

    const [checked, setChecked] = useState({
        terms: true,
        commission: false,
        refund: false,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setData({
            ...data,
            [name]: value
        });
    };

    const handleCheckbox = (e) => {
        const { name, checked: value } = e.target;

        setChecked((prev) => ({
            ...prev,
            [name]: value
        }));

        setData({
            ...data,
            [name]: value
        });
    };

    return (
        <div>
            <h2 className="h4 fw-semibold text-dark mb-4">
                Verification
            </h2>

            {/* Aadhar */}
            <div className="card p-4 mb-4">
                <label>Aadhar Number *</label>
                <input
                    type="text"
                    name="aadhar"
                    value={data.aadhar || ""}
                    onChange={handleChange}
                    className="form-control"
                />
            </div>

            {/* Agreements */}
            <div className="card p-4">
                <label>
                    <input
                        type="checkbox"
                        name="terms"
                        checked={checked.terms}
                        onChange={handleCheckbox}
                    />
                    Accept Terms
                </label>

                <label>
                    <input
                        type="checkbox"
                        name="commission"
                        checked={checked.commission}
                        onChange={handleCheckbox}
                    />
                    Accept Commission Policy
                </label>

                <label>
                    <input
                        type="checkbox"
                        name="refund"
                        checked={checked.refund}
                        onChange={handleCheckbox}
                    />
                    Accept Refund Policy
                </label>
            </div>
        </div>
    );
}
